export interface ArtifactDownloadLocation {
  origin: string;
  assign(url: string): void;
}

export interface BlobDownloadTarget {
  createObjectUrl(blob: Blob): string;
  revokeObjectUrl(url: string): void;
  click(url: string, filename: string): void;
  defer(callback: () => void): void;
}

export function safeArtifactDownloadUrl(raw: string, origin: string): string {
  const url = new URL(raw, origin);
  if (url.username || url.password) {
    throw new Error("The download capability contained embedded credentials.");
  }
  if (url.protocol !== "https:" && url.origin !== origin) {
    throw new Error("The download capability was not an authorized URL.");
  }
  return url.href;
}

export function startArtifactDownload(
  raw: string,
  target: ArtifactDownloadLocation = window.location,
): void {
  target.assign(safeArtifactDownloadUrl(raw, target.origin));
}

export function startBlobDownload(
  blob: Blob,
  filename: string,
  target?: BlobDownloadTarget,
): void {
  const resolvedTarget =
    target ??
    ({
      createObjectUrl: (content) => URL.createObjectURL(content),
      revokeObjectUrl: (url) => URL.revokeObjectURL(url),
      click: (url, downloadFilename) => {
        const anchor = window.document.createElement("a");
        anchor.href = url;
        anchor.download = downloadFilename;
        anchor.click();
      },
      defer: (callback) => window.setTimeout(callback, 0),
    } satisfies BlobDownloadTarget);
  const url = resolvedTarget.createObjectUrl(blob);
  try {
    resolvedTarget.click(url, filename);
  } catch (error) {
    resolvedTarget.revokeObjectUrl(url);
    throw error;
  }
  resolvedTarget.defer(() => resolvedTarget.revokeObjectUrl(url));
}
